import { ref } from 'vue';

export function validateSelection(flavours, boxSize, wantCard, selectedCard) {
  const flavorError = ref(false);
  const cardError = ref(false);

  if (flavours.length < boxSize) {
    flavorError.value = true;
  } else {
    flavorError.value = false;
  }

  if (wantCard && !selectedCard) {
    cardError.value = true;
  } else {
    cardError.value = false;
  }

  return { isValid: !flavorError.value && !cardError.value, flavorError, cardError };
}